import PropTypes from 'prop-types';
import { Component } from 'react';

import withDeviceType from '../../hoc/with-device-type';
import styles from './accessibility-listener.scss';

export class AccessibilityListener extends Component {
  handleTabKeyUp = e => {
    if (e.which === 9 && document.body.classList.contains(styles.noOutline)) {
      document.body.classList.remove(styles.noOutline);
    }
  };

  handleClick = () => {
    if (!document.body.classList.contains(styles.noOutline)) {
      document.body.classList.add(styles.noOutline);
    }
  };

  componentDidMount() {
    document.body.classList.add(styles.noOutline);

    if (!this.props.isMobile) {
      document.addEventListener('keyup', this.handleTabKeyUp);
      document.addEventListener('click', this.handleClick);
    }
  }

  componentWillUnmount() {
    if (!this.props.isMobile) {
      document.removeEventListener('keyup', this.handleTabKeyUp);
      document.removeEventListener('click', this.handleClick);
    }
  }

  render() {
    return null;
  }
}

AccessibilityListener.propTypes = {
  isMobile: PropTypes.bool.isRequired,
};

export default withDeviceType(AccessibilityListener);



// WEBPACK FOOTER //
// ./app/components/accessibility-listener/accessibility-listener.js